<template>
  <product
    :product-logo="productLogo"
    :product-brief="productBrief"
    :carousel-images="carouselImages"
  >
    <p>
      Rodrix fasteners were in business for a while now, and so was
      their website... <br />
      Eventually, it couldn't handle the business tasks
      they needed. So after a series of consulting/planning sessions -
      We made a call to rebuild the website from scratch using the
      latest technologies. The challenging part was the need to keep the
      database structure intact, as it was linked to an external
      catalog/accounting service.
    </p>
    <p>
      Their B2B website is basically a wholesale product catalog for other
      businesses. My job was to re-create it on
      the updated tech stack. The website included:
      <ul>
        <li>
          Products listing, split by categories with an infinite level of
          depth.
        </li>
        <li>
          Shopping cart + purchase orders for logged-in users.
        </li>
        <li>
          Admin area to manage customers and orders.
        </li>
        <li>
          Adding dynamic filters for each category (NEW Feature).
        </li>
        <li>
          Filter products within a current category and show everything
          that fits the filtered set within the current category or its
          sub-categories.
        </li>
        <li>
          Keep the integration with a 3rd party system to be able to
          import/update the product listing.
        </li>
      </ul>
    </p>
    <p>
      We were able to recreate all the features they had, implement a
      requested business-logic and overall, make a website experience a
      lot more smooth and user-friendly. At the moment the new website
      is functioning great and the next phase of updates is being
      planned.
    </p>
    <template v-slot:footer>
      <div class="col-12 mt-3 py-2 next-btn">
        <router-link :to="{ name: 'max-tv' }">
          <span>Next &mdash; MaxTV</span>
          <font-awesome-icon icon="arrow-right" size="3x" />
        </router-link>
      </div>
    </template>
  </product>
</template>

<script>
import Product from '@/components/product/Product'
export default {
  components: { Product },
  data() {
    return {
      productLogo: require('@/assets/img/products/Rodrix.png'),
      productBrief: 'One stop shop for all your fastener needs! \n Proudly serving St Jacobs, Elmira, Kitchener, Waterloo, Cambridge, Guelph, and Surrounding Areas.',
      carouselImages: [
        require('@/assets/img/products/rdrx/3.png'),
        require('@/assets/img/products/rdrx/1.png'),
        require('@/assets/img/products/rdrx/4.png'),
        require('@/assets/img/products/rdrx/2.png'),
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
section.main {
  background-image: linear-gradient(#254c914a, #9ab9d730),
    url("~@/assets/img/products/rdrx/cover.jpg");
}
</style>
